import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome to Riddhi"); navigate("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative order-2">
        <img src="https://images.pexels.com/photos/28405815/pexels-photo-28405815.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/60 to-transparent" />
        <div className="absolute bottom-10 left-10 text-white max-w-md">
          <img src="https://customer-assets.emergentagent.com/job_riddhi-elegance/artifacts/8b0yz6uh_ffaab141-db10-4f1b-8d78-dd8685cdd1f1.jpg"
               alt="Riddhi" className="h-20 w-auto object-contain rounded-sm mb-5" />
          <div className="font-serif-h text-2xl leading-tight">Begin a quiet love affair with craft.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 md:px-16 py-20">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">New Here</div>
          <h1 className="font-serif-h font-light text-4xl text-stone-900">Create Account</h1>
          <div className="mt-10 space-y-8">
            <div><label className="text-[11px] tracking-overline uppercase text-stone-500">Full Name</label>
              <input required className="input-line" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" /></div>
            <div><label className="text-[11px] tracking-overline uppercase text-stone-500">Email</label>
              <input required type="email" className="input-line" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" /></div>
            <div><label className="text-[11px] tracking-overline uppercase text-stone-500">Password</label>
              <input required type="password" minLength={6} className="input-line" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" /></div>
          </div>
          <button disabled={loading} className="btn-ink w-full justify-center mt-10 disabled:opacity-50" data-testid="reg-submit">
            {loading ? "Creating..." : "Create Account"}
          </button>

          <div className="mt-8 flex items-center gap-4">
            <div className="flex-1 h-px bg-stone-200" />
            <span className="text-[10px] tracking-overline uppercase text-stone-400">or</span>
            <div className="flex-1 h-px bg-stone-200" />
          </div>
          <div className="mt-6">
            <GoogleSignInButton label="Continue with Google" />
          </div>
          <div className="mt-8 text-sm text-stone-600 text-center">
            Already have an account? <Link to="/login" className="text-[#D4AF37] hover:underline">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
